import moment from "moment";
import { LOCALSTORAGE_AUTH_USER } from "../constants/LocalStorage";
import crossCheckIcon from "../../assets/check-icons/cross-check.png";
import CrossUnCheck from "../../assets/check-icons/cross-uncheck.png";
import dotCheckIcon from "../../assets/check-icons/dot-check.png";
import DotUnCheck from "../../assets/check-icons/dot-uncheck.png";
import tickCheckIcon from "../../assets/check-icons/tick-check.png";
import TickUnCheck from "../../assets/check-icons/tick-uncheck.png";

//Alert Toast
export const getAlertToast = (type = "success", text = "", timer = 5000) => ({
  toast: true,
  position: "bottom",
  titleText: text,
  type: type,
  showConfirmButton: false,
  timer: timer,
});

//Alert Toast without time
export const getAlert = (type = "success", text = "") => ({
  position: "center",
  type: type,
  text: text,
  customClass: {
    confirmButton: "btn-shadow btn btn-primary btn-lg",
  },
  buttonsStyling: false,
  confirmButtonColor: "#000",
});

export const getConfirm = (
  icon = "success", // fixed after upgrade
  text = "",
  confirmButtonText = "Yes"
) => ({
  text: text,
  type: icon,
  showCancelButton: true,
  confirmButtonColor: "#3085d6", // fixed after upgrade
  cancelButtonColor: "#939392",
  confirmButtonText: confirmButtonText,
});

// #rbp Get String first letter as capital
export const FirstLetterAsCaps = (givenList = {}) => {
  for (const key in givenList) {
    const value = givenList[key];
    givenList[key] = value.charAt(0).toUpperCase() + value.slice(1);
  }
  return givenList;
};

//#rbp Date format
export function dateFormat(date) {
  if (moment(date).isValid()) {
    return moment(date).format("DD/MM/YYYY");
  } else {
    return "";
  }
}

//#rbp Date and Time format
export function dateTimeFormat(date, format) {
  if (moment(date).isValid()) {
    return moment(date).format(format);
  } else {
    return "";
  }
}

//Get Re-Formatted Phone Number
export const GetReFormattedPhoneNumber = (phoneNumber) => {
  return phoneNumber.trim().split("-").join("");
};

// Single Variable First Letter caps
export const SingleStringFirstLetterCaps = (value) => {
  return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
};

// Convert Phone number with hyphen
export function converToHyphenedPhoneNumber(phoneNumber) {
  return (
    phoneNumber.slice(0, 3) +
    "-" +
    phoneNumber.slice(3, 6) +
    "-" +
    phoneNumber.slice(6)
  );
}

//Phone Number Format onChange Field
export const normalizePhoneNumberFormatOnChange = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;
  if (cvLength < 4) return currentValue;
  if (cvLength < 7)
    return `${currentValue.slice(0, 3)}-${currentValue.slice(3)}`;
  return `${currentValue.slice(0, 3)}-${currentValue.slice(
    3,
    6
  )}-${currentValue.slice(6, 10)}`;
};

//amount format
export const amountFormat = (amount) => {
  return `$${parseFloat(amount).toFixed(2)}`;
};

//Float Fixed Data
export const FloatFixedFormat = (value) => parseFloat(value).toFixed(2);

export const getCurrentUserId = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return userData?.userId;
};

export const getCurrentAgencyId = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return userData?.agencyId;
};

export const getCurrentUserName = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return `${SingleStringFirstLetterCaps(
    userData?.firstName
  )} ${SingleStringFirstLetterCaps(userData?.lastName)}`;
};

export const getCurrentProfile = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return userData?.profileImage ? userData?.profileImage : "";
};

export const getCurrentRole = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return userData?.role ? userData?.role : "";
};

export const getCurrentEmail = () => {
  let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));
  return userData?.email ? userData?.email : "";
};

export const getDateString = (string) =>
  string && new Date(string).toLocaleDateString();

export const getCountryCode = () => "(+1) ";

//convert uint8ToBase64
export const Uint8ToBase64 = (u8Arr) => {
  var CHUNK_SIZE = 0x8000;
  var index = 0;
  var length = u8Arr.length;
  var result = "";
  var slice;
  while (index < length) {
    slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
    result += String.fromCharCode.apply(null, slice);
    index += CHUNK_SIZE;
  }
  return btoa(result);
};

//convert base64 to urlBlob
export const b64toBlob = (b64Data, contentType) => {
  var byteCharacters = atob(b64Data);

  var byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    var slice = byteCharacters.slice(offset, offset + 512),
      byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

//Detect Card Type
export const detectCardType = (number) => {
  let cardType = null;
  var re = {
    electron: /^(4026|417500|4405|4508|4844|4913|4917)\d+$/,
    maestro:
      /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
    dankort: /^(5019)\d+$/,
    interpayment: /^(636)\d+$/,
    unionpay: /^(62|88)\d+$/,
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    mastercard: /^5[1-5][0-9]{14}$/,
    amex: /^3[47][0-9]{13}$/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
  };

  for (var key in re) {
    if (re[key].test(number)) {
      cardType = key;
    }
  }
  return { isCardValid: !!cardType, cardType };
};

//Tax Id Format onChange Field
export const formatIntoHyphenedTaxid = (value) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;
  if (cvLength < 3) return currentValue;
  return `${currentValue.slice(0, 2)}-${currentValue.slice(2, 9)}`;
};

//get icon based of checkboxtype and value
export const getCheckBoxIcon = (checkboxType, checkboxValue) => {
  if (checkboxType == "Cross") {
    return checkboxValue ? crossCheckIcon : CrossUnCheck;
  } else if (checkboxType == "Tick") {
    return checkboxValue ? tickCheckIcon : TickUnCheck;
  } else {
    return checkboxValue ? dotCheckIcon : DotUnCheck;
  }
};

//convert url to base64
export const toDataURL = (url, callback) => {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
};

//Convert to US DateTime Format
export function convertToUSDateTimeFormat(date) {
  if (moment(date).isValid()) {
    return moment(date).format("MM/DD/YYYY hh:mm A");
  } else {
    return "";
  }
}

// Fixed two digits float value
export const fixedTwoDigitsFloatValue = (value) => parseFloat(value).toFixed(2);

export function fillParagraph(text, font, fontSize, maxWidth) {
  var paragraphs = text.split("\n");
  for (let index = 0; index < paragraphs.length; index++) {
    var paragraph = paragraphs[index];
    if (font.widthOfTextAtSize(paragraph, fontSize) > maxWidth) {
      var words = paragraph.split(" ");
      var newParagraph = [];
      var i = 0;
      newParagraph[i] = [];
      for (let k = 0; k < words.length; k++) {
        var word = words[k];
        newParagraph[i].push(word);
        if (
          font.widthOfTextAtSize(newParagraph[i].join(" "), fontSize) > maxWidth
        ) {
          newParagraph[i].splice(-1); // retira a ultima palavra
          i = i + 1;
          newParagraph[i] = [];
          newParagraph[i].push(word);
        }
      }
      paragraphs[index] = newParagraph.map((p) => p.join(" ")).join("  \n ");
    }
  }
  return paragraphs.join(" \n ");
}
